import React, { useState } from "react";
import { format, parse, isValid } from "date-fns";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { CalendarBlank } from "@phosphor-icons/react";

// A polished shadcn Calendar + Popover date picker that speaks the same
// "YYYY-MM-DD" string value as a native <input type="date"> would.
export function DatePicker({ value, onChange, placeholder = "Pick a date", testId, className = "" }) {
  const [open, setOpen] = useState(false);
  const parsed = value ? parse(value, "yyyy-MM-dd", new Date()) : undefined;
  const selected = parsed && isValid(parsed) ? parsed : undefined;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className={`dos-input flex items-center justify-between gap-2 text-left w-full ${!selected ? "text-neutral-400" : ""} ${className}`}
        >
          <span className="truncate">{selected ? format(selected, "dd MMM yyyy") : placeholder}</span>
          <CalendarBlank size={14} className="text-neutral-400 shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={selected}
          defaultMonth={selected}
          onSelect={(d) => { if (d) { onChange(format(d, "yyyy-MM-dd")); setOpen(false); } }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
